<template>
  <div class="relative" ref="userDropdown">
    <button 
      @click="toggleUserMenu" 
      class="flex items-center text-sm rounded-full focus:outline-none p-1 hover:bg-gray-100 dark:hover:bg-gray-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-gray-800"
    >
      <img class="h-8 w-8 rounded-full object-cover" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="User Profile" />
      <span class="hidden md:block ml-2 text-gray-700 dark:text-gray-300">{{ userName }}</span>
      <svg class="ml-1 h-4 w-4 text-gray-400 dark:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
    
    <!-- User Menu Dropdown -->
    <div v-if="showUserMenu" class="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg py-1 z-50 border border-gray-200 dark:border-gray-700">
      <router-link to="/admin/profile" class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Profil</router-link>
      <router-link to="/admin/settings" class="block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Einstellungen</router-link>
      <button @click="logout" class="w-full text-left block px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700">Abmelden</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { authService } from '@/services/api'

const router = useRouter()
const userStore = useUserStore()
const userDropdown = ref(null)
const showUserMenu = ref(false)

// Rufe den Benutzernamen aus dem Store oder localStorage ab
const userName = computed(() => {
  if (userStore.user && userStore.user.fullName) {
    return userStore.user.fullName;
  }
  
  try {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    return userData.fullName || 'Benutzer';
  } catch (e) {
    return 'Benutzer';
  }
})

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value
}

// Schließen beim Klick außerhalb
const handleClickOutside = (event) => {
  if (userDropdown.value && !userDropdown.value.contains(event.target)) {
    showUserMenu.value = false
  }
}

// Logout-Funktion
const logout = async () => {
  try {
    // Abmeldung im Backend
    await authService.logout().catch(err => console.warn('Fehler beim Server-Logout:', err));
    
    // Lokale Daten löschen
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    
    // Store zurücksetzen
    userStore.clearUser()
    
    // Zur Login-Seite navigieren
    console.log('Abmeldung erfolgreich, leite zu Login weiter...')
    router.push('/login')
  } catch (error) {
    console.error('Fehler beim Logout:', error)
    
    // Falls ein Fehler auftritt, trotzdem lokal abmelden
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    userStore.clearUser()
    router.push('/login')
  }
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})
</script> 